export const CHANGE_PASSWORD_REQUESTED = 'CHANGE_PASSWORD_REQUESTED';
export const CHANGE_PASSWORD_COMPLETED = 'CHANGE_PASSWORD_COMPLETED';
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED';
export const RESET_CHANGE_PASSWORD_REQUESTED =
  'RESET_CHANGE_PASSWORD_REQUESTED';
export const RESET_CHANGE_PASSWORD_COMPLETED =
  'RESET_CHANGE_PASSWORD_COMPLETED';
export const RESET_CHANGE_PASSWORD_FAILED = 'RESET_CHANGE_PASSWORD_FAILED';
